import React from 'react'
import { useEffect, useState } from 'react'
import moment from 'moment'
import Map from './graphs/MapComp'

function Bar(props) {
	const [show, setShow] = useState(null)
	useEffect(() => {
		if (props.location?.hasOwnProperty('secondRange') && props.multipleState.compare) {
			setShow(true)
		} else {
			setShow(false)
		}
		console.log('map ', props.location)
	}, [props.location, props.multipleState.compare])

	return (
		<div style={{ width: '100%' }}>
			<h2>Répartition géographique des utilisateurs</h2>
			<br />
			<div
				style={{
					display: show ? 'flex' : 'block',
					justifyContent: 'space-between',
					marginTop: 20,
				}}
			>
				<>
					<p
						style={{
							fontWeight: 'bold',
							textAlign: 'left',
							marginTop: 20,
							position: 'absolute',
							color: 'rgb(61, 145, 255)',
						}}
					>
						{moment(new Date(props.multipleState.selection.startDate)).format(
							'YYYY/MM/DD'
						)}{' '}
						-{' '}
						{moment(new Date(props.multipleState.selection.endDate)).format(
							'YYYY/MM/DD'
						)}
					</p>
					{props.location && <Map show={show} data={props.location?.firstRange} />}
				</>
				{show && props.multipleState.compare && (
					<>
						<p
							className='compare'
							style={{
								fontWeight: 'bold',
								position: 'absolute',
								marginTop: 20,
								left: '50%',
								color: 'rgb(62, 207, 142)',
							}}
						>
							{moment(new Date(props.multipleState.compare.startDate)).format(
								'YYYY/MM/DD'
							) +
								' - ' +
								moment(new Date(props.multipleState.compare.endDate)).format(
									'YYYY/MM/DD'
								)}
						</p>
						<Map show={show} data={props.location?.secondRange} />
					</>
				)}
			</div>
		</div>
	)
}

export default Bar
